import { z } from "zod";

export const freightAssignmentUpsertSchema = z.object({
  carrierId: z.number().int(),
  plantId: z.number().int(),
  role: z.string().min(1),
  assignedUserId: z.number().int().optional(),
});
export type FreightAssignmentUpsertInput = z.infer<typeof freightAssignmentUpsertSchema>;
